import { createClient } from '@supabase/supabase-js';

// Get Supabase credentials from environment variables (injected at build time by Vite)
const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID || '';
const publicAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!publicAnonKey) {
  throw new Error(
    'VITE_SUPABASE_ANON_KEY is missing. Set it in .env (local) or Vercel → Project → Settings → Environment Variables, then rebuild.'
  );
}

// Use the default Supabase URL for the client SDK
// The custom domain (auth.productradar.co) is configured in Supabase Dashboard
// but the SDK still needs to use the project-specific URL
const supabaseUrl = projectId ? `https://${projectId}.supabase.co` : '';

if (!supabaseUrl) {
  throw new Error(
    'VITE_SUPABASE_PROJECT_ID is missing. Set it in .env (local) or Vercel → Project → Settings → Environment Variables, then rebuild.'
  );
}

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, publicAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true, // CRITICAL: This makes Supabase detect OAuth tokens in URL
    flowType: 'pkce', // Use PKCE flow for better security
  },
});

// Helper function to get current user
export async function getCurrentUser() {
  const {
    data: { user },
    error,
  } = await supabase.auth.getUser();
  if (error) throw error;
  return user;
}

